<template>
	<view class="box">
		<view class="box-info">
			<text>验证当前登录手机号</text>
			<text>请输入 153****1677 收到的短信验证码</text>
		</view>
		<view class="list">
			<view class="input">
				<view class="input-label">手机号</view>
				<input type="number" placeholder="请输入手机号" />
			</view>
			<view class="input">
				<view class="input-label">短信验证码</view>
				<input type="number" placeholder="请输入验证码" />
				<view class="input-send">获取验证码</view>
			</view>
		</view>
		<view class="btn">下一步</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 38rpx 30rpx;
		box-sizing: border-box;
		.btn {
			width: 100%;
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			font-weight: 600;
			font-size: 32rpx;
			color: #FFFFFF;
			background: #004096;
			border-radius: 44rpx;
			margin-top: 60rpx;
		}
		.list {
			width: 100%;
			margin-top: 50rpx;
			.input {
				width: 100%;
				height: 100rpx;
				display: flex;
				align-items: center;
				border-bottom: 1rpx solid #E5E5E5;
				.input-label {
					width: 180rpx;
					flex-shrink: 0;
					font-weight: 600;
					font-size: 28rpx;
					color: #111111;
					margin-right: 30rpx;
				}
				input {
					flex: 1;
					height: 100%;
					font-weight: 400;
					font-size: 28rpx;
					color: #111111;
				}
				.input-send {
					flex-shrink: 0;
					font-weight: 400;
					font-size: 28rpx;
					color: #004096;
					margin-left: 30rpx;
				}
			}
		}
		.box-info {
			width: 100%;
			display: flex;
			flex-direction: column;
			text {
				&:nth-child(1) {
					font-weight: 600;
					font-size: 40rpx;
					color: #111111;
				}
				&:nth-child(2) {
					font-weight: 400;
					font-size: 26rpx;
					color: #999999;
					margin-top: 20rpx;
				}
			}
		}
	}
</style>